import { useQuery } from '@apollo/client';

import { EventProduct, getCompletedPopupEventDetails } from '@/api';

import { PopupEventVendorDetailsCompleted } from '../types';
import { parseEventVendorIds } from '../helpers';

type UsePopupCompletedEvent = {
  event: PopupEventVendorDetailsCompleted | undefined;
  loading: boolean;
};

// The route param can carry several ids for aggregated delivery cards, so the
// query takes a list. POPUP events are not aggregated, hence the first result.
export const usePopupCompletedEvent = (id: string): UsePopupCompletedEvent => {
  const { data, loading } = useQuery(getCompletedPopupEventDetails, {
    variables: { input: { eventVendorIds: parseEventVendorIds(id), productType: EventProduct.POPUP } },
  });

  return {
    event: data?.getEventVendors?.eventVendors?.[0] as PopupEventVendorDetailsCompleted | undefined,
    loading,
  };
};
